import * as React from 'react';
import { Selectors } from '@grandvisionhq/auth';
import { useDispatch, useIntl, useFeatureToggles, useSelector } from '@grandvisionhq/state';
import { toggleAccountCreation, setChangedOptIns } from '../../../actions.js';
import { shouldCreateAccount } from '../../../selectors.js';
import { shouldValidateMyAccount } from '../../../StepShipping/selectors.js';
import { CreateAccount } from '../components/CreateAccount.js';
import { useCheckoutSettings } from '../../../context/CheckoutSettings/context.js';

const CreateAccountContainer = ()=>{
    const dispatch = useDispatch();
    const { getLabel , getFormattedLabel  } = useIntl();
    const { account  } = useCheckoutSettings();
    const { isMyAccountEnabled  } = useFeatureToggles();
    const isLoggedIn = useSelector(Selectors.isLoggedIn);
    const shouldCreateAccountBoolean = useSelector(shouldCreateAccount);
    const shouldValidateMyAccountBoolean = useSelector(shouldValidateMyAccount);
    const implicitAccountCreation = !!(account === null || account === void 0 ? void 0 : account.implicitAccountCreation);
    React.useEffect(()=>{
        if (implicitAccountCreation) {
            dispatch(toggleAccountCreation({
                shouldCreateAccount: true
            }));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleChange = ({ checked  })=>{
        // update the contact details form for validation purposes
        dispatch(toggleAccountCreation({
            shouldCreateAccount: checked
        }));
        if (!checked) {
            // clear opt-ins when account creation is unchecked
            dispatch(setChangedOptIns({}));
        }
    };
    const labels = React.useMemo(()=>{
        return {
            text: `${getFormattedLabel((account === null || account === void 0 ? void 0 : account.createAccountRequired) ? 'checkout.createAccount.agreement' : 'account.createAccount.label', {
                parseLink: true
            })}${(account === null || account === void 0 ? void 0 : account.createAccountRequired) ? ' *' : ''}`.trim(),
            agreementError: !shouldCreateAccountBoolean && shouldValidateMyAccountBoolean ? getLabel('checkout.createAccount.agreement.error') : undefined
        };
    }, [
        account === null || account === void 0 ? void 0 : account.createAccountRequired,
        getFormattedLabel,
        getLabel,
        shouldCreateAccountBoolean,
        shouldValidateMyAccountBoolean, 
    ]);
    if (!isMyAccountEnabled || isLoggedIn || implicitAccountCreation) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(CreateAccount, {
        checked: shouldCreateAccountBoolean,
        errorMessage: labels.agreementError,
        label: labels.text,
        onChange: handleChange
    });
};

export { CreateAccountContainer };
//# sourceMappingURL=CreateAccountContainer.js.map
